/* tslint:disable */
import { Action } from '@ngrx/store';

export * from './students-actions/students-postsecondary-actions';

export interface IListSort {
  [key: number]: {
    columnKey: string;
    sort: 'asc' | 'desc';
  };
}

export interface IListDimensions {
  [key: string]: string;
}

/** ALL STUDENTS ACTIONS */
export const BULK_UPDATE_STUDENTS = '[Portal] Bulk Update Students';
export const BULK_UPDATE_STUDENTS_SUCCESS = '[Portal] Bulk Update Students Success';
export const BULK_UPDATE_STUDENTS_FAIL = '[Portal] Bulk Update Students Fail';

export class BulkUpdateStudents implements Action {
  readonly type = BULK_UPDATE_STUDENTS;
  constructor(public payload: any) {}
}

export class BulkUpdateStudentsSuccess implements Action {
  readonly type = BULK_UPDATE_STUDENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class BulkUpdateStudentsFail implements Action {
  readonly type = BULK_UPDATE_STUDENTS_FAIL;
  constructor(public payload: any) {}
}

/** MY_STUDENTS_ACTIONS: Todo - move to own file */
// init actions
export const LOAD_MY_STUDENTS = '[Portal] Load My Students';
export const UPDATE_MY_STUDENTS = '[Portal] Update My Students';
export const BULK_UPDATE_MY_STUDENTS = '[Portal] Bulk Update My Students';

export const UPDATE_MY_STUDENTS_SORT = '[Portal] Update My Students Sort';
export const UPDATE_MY_STUDENTS_DIMENSIONS = '[Portal] Update My Students Dimensions';
// success actions
export const LOAD_MY_STUDENTS_SUCCESS = '[Portal] Load My Students Success';
export const UPDATE_MY_STUDENTS_SUCCESS = '[Portal] Update My Students Success';
export const BULK_UPDATE_MY_STUDENTS_SUCCESS = '[Portal] Bulk Update My Students Success';
export const UPDATE_MY_STUDENTS_PROJECTION_SUCCESS = '[Portal] Update My Students Projection Success';
// failure actions
export const LOAD_MY_STUDENTS_FAIL = '[Portal] Load My Students Fail';
export const UPDATE_MY_STUDENTS_FAIL = '[Portal] Update My Students Fail';
export const BULK_UPDATE_MY_STUDENTS_FAIL = '[Portal] Bulk Update My Students Fail';
export const UPDATE_MY_STUDENTS_PROJECTION_FAIL = '[Portal] Update My Students Projection Fail';

export class UpdateMyStudentsDimensions implements Action {
  readonly type = UPDATE_MY_STUDENTS_DIMENSIONS;
  constructor(public payload: IListDimensions) {}
}

export class UpdateMyStudentsSort implements Action {
  readonly type = UPDATE_MY_STUDENTS_SORT;
  constructor(public payload: IListSort) {}
}

export class LoadMyStudents implements Action {
  readonly type = LOAD_MY_STUDENTS;
  constructor(public payload: any) {}
}

export class UpdateMyStudents implements Action {
  readonly type = UPDATE_MY_STUDENTS;
  constructor(public payload: any) {}
}

export class BulkUpdateMyStudents implements Action {
  readonly type = BULK_UPDATE_MY_STUDENTS;
  constructor(public payload: any) {}
}

export class LoadMyStudentsSuccess implements Action {
  readonly type = LOAD_MY_STUDENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdateMyStudentsSuccess implements Action {
  readonly type = UPDATE_MY_STUDENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class BulkUpdateMyStudentsSuccess implements Action {
  readonly type = BULK_UPDATE_MY_STUDENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdateMyStudentsProjectionSuccess implements Action {
  readonly type = UPDATE_MY_STUDENTS_PROJECTION_SUCCESS;
  constructor(public payload: any) {}
}

export class LoadMyStudentsFail implements Action {
  readonly type = LOAD_MY_STUDENTS_FAIL;
  constructor(public payload: any) {}
}

export class UpdateMyStudentsFail implements Action {
  readonly type = UPDATE_MY_STUDENTS_FAIL;
  constructor(public payload: any) {}
}
export class BulkUpdateMyStudentsFail implements Action {
  readonly type = BULK_UPDATE_MY_STUDENTS_FAIL;
  constructor(public payload: any) {}
}

export class UpdateMyStudentsProjectionFail implements Action {
  readonly type = UPDATE_MY_STUDENTS_PROJECTION_FAIL;
  constructor(public payload: any) {}
}

/** ATTENDANCE_STUDENTS_ACTIONS: TODO - move to own file */
// init actions
export const LOAD_ATTENDANCE_STUDENTS = '[Portal] Load Attendance Students';
export const UPDATE_ATTENDANCE_STUDENTS = '[Portal] Update Attendance Students';
export const BULK_UPDATE_ATTENDANCE_STUDENTS = '[Portal] Bulk Update Attendance Students';

export const UPDATE_ATTENDANCE_STUDENTS_SORT = '[Portal] Update Attendance Students Sort';
export const UPDATE_ATTENDANCE_STUDENTS_DIMENSIONS = '[Portal] Update Attendance Students Dimensions';
// success actions
export const LOAD_ATTENDANCE_STUDENTS_SUCCESS = '[Portal] Load Attendance Students Success';
export const UPDATE_ATTENDANCE_STUDENTS_SUCCESS = '[Portal] Update Attendance Students Success';
export const BULK_UPDATE_ATTENDANCE_STUDENTS_SUCCESS = '[Portal] Bulk Update Attendance Students Success';
export const UPDATE_ATTENDANCE_STUDENTS_PROJECTION_SUCCESS = '[Portal] Update Attendance Students Projection Success';
// failure actions
export const LOAD_ATTENDANCE_STUDENTS_FAIL = '[Portal] Load Attendance Students Fail';
export const UPDATE_ATTENDANCE_STUDENTS_FAIL = '[Portal] Update Attendance Students Fail';
export const BULK_UPDATE_ATTENDANCE_STUDENTS_FAIL = '[Portal] Bulk Update Attendance Students Fail';
export const UPDATE_ATTENDANCE_STUDENTS_PROJECTION_FAIL = '[Portal] Update Attendance Projection Fail';

export class UpdateAttendanceStudentsSort implements Action {
  readonly type = UPDATE_ATTENDANCE_STUDENTS_SORT;
  constructor(public payload: IListSort) {}
}

export class UpdateAttendanceStudentsDimensions implements Action {
  readonly type = UPDATE_ATTENDANCE_STUDENTS_DIMENSIONS;
  constructor(public payload: IListDimensions) {}
}

export class LoadAttendanceStudents implements Action {
  readonly type = LOAD_ATTENDANCE_STUDENTS;
  constructor(public payload: any) {}
}

export class UpdateAttendanceStudents implements Action {
  readonly type = UPDATE_ATTENDANCE_STUDENTS;
  constructor(public payload: any) {}
}

export class BulkUpdateAttendanceStudents implements Action {
  readonly type = BULK_UPDATE_ATTENDANCE_STUDENTS;
  constructor(public payload: any) {}
}

export class LoadAttendanceStudentsSuccess implements Action {
  readonly type = LOAD_ATTENDANCE_STUDENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdateAttendanceStudentsSuccess implements Action {
  readonly type = UPDATE_ATTENDANCE_STUDENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class BulkUpdateAttendanceStudentsSuccess implements Action {
  readonly type = BULK_UPDATE_ATTENDANCE_STUDENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdateAttendanceStudentsProjectionSuccess implements Action {
  readonly type = UPDATE_ATTENDANCE_STUDENTS_PROJECTION_SUCCESS;
  constructor(public payload: any) {}
}

export class LoadAttendanceStudentsFail implements Action {
  readonly type = LOAD_ATTENDANCE_STUDENTS_FAIL;
  constructor(public payload: any) {}
}

export class UpdateAttendanceStudentsFail implements Action {
  readonly type = UPDATE_ATTENDANCE_STUDENTS_FAIL;
  constructor(public payload: any) {}
}

export class BulkUpdateAttendanceStudentsFail implements Action {
  readonly type = BULK_UPDATE_ATTENDANCE_STUDENTS_FAIL;
  constructor(public payload: any) {}
}

export class UpdateAttendanceStudentsProjectionFail implements Action {
  readonly type = UPDATE_ATTENDANCE_STUDENTS_PROJECTION_FAIL;
  constructor(public payload: any) {}
}

/** ACADEMIC_STUDENTS_ACTIONS */
export const LOAD_ACADEMIC_STUDENTS = '[Portal] Load Academic Students';
export const UPDATE_ACADEMIC_STUDENTS = '[Portal] Update Academic Students';
export const BULK_UPDATE_ACADEMIC_STUDENTS = '[Portal] Bulk Update Academic Students';

export const UPDATE_ACADEMIC_STUDENTS_SORT = '[Portal] Update Academic Students Sort';
export const UPDATE_ACADEMIC_STUDENTS_DIMENSIONS = '[Portal] Update Academic Students Dimensions';
// success actions
export const LOAD_ACADEMIC_STUDENTS_SUCCESS = '[Portal] Load Academic Students Success';
export const UPDATE_ACADEMIC_STUDENTS_SUCCESS = '[Portal] Update Academic Students Success';
export const BULK_UPDATE_ACADEMIC_STUDENTS_SUCCESS = '[Portal] Bulk Update Academic Students Success';
export const UPDATE_ACADEMIC_STUDENTS_PROJECTION_SUCCESS = '[Portal] Update Academic Students Projection Success';
// failure actions
export const LOAD_ACADEMIC_STUDENTS_FAIL = '[Portal] Load Academic Students Fail';
export const UPDATE_ACADEMIC_STUDENTS_FAIL = '[Portal] Update Academic Students Fail';
export const BULK_UPDATE_ACADEMIC_STUDENTS_FAIL = '[Portal] Bulk Update Academic Students Fail';
export const UPDATE_ACADEMIC_STUDENTS_PROJECTION_FAIL = '[Portal] Update Academic Projection Fail';

export class UpdateAcademicStudentsSort implements Action {
  readonly type = UPDATE_ACADEMIC_STUDENTS_SORT;
  constructor(public payload: IListSort) {}
}

export class UpdateAcademicStudentsDimensions implements Action {
  readonly type = UPDATE_ACADEMIC_STUDENTS_DIMENSIONS;
  constructor(public payload: IListDimensions) {}
}

export class LoadAcademicStudents implements Action {
  readonly type = LOAD_ACADEMIC_STUDENTS;
  constructor(public payload: any) {}
}

export class UpdateAcademicStudents implements Action {
  readonly type = UPDATE_ACADEMIC_STUDENTS;
  constructor(public payload: any) {}
}

export class BulkUpdateAcademicStudents implements Action {
  readonly type = BULK_UPDATE_ACADEMIC_STUDENTS;
  constructor(public payload: any) {}
}

export class LoadAcademicStudentsSuccess implements Action {
  readonly type = LOAD_ACADEMIC_STUDENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdateAcademicStudentsSuccess implements Action {
  readonly type = UPDATE_ACADEMIC_STUDENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class BulkUpdateAcademicStudentsSuccess implements Action {
  readonly type = BULK_UPDATE_ACADEMIC_STUDENTS_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdateAcademicStudentsProjectionSuccess implements Action {
  readonly type = UPDATE_ACADEMIC_STUDENTS_PROJECTION_SUCCESS;
  constructor(public payload: any) {}
}

export class LoadAcademicStudentsFail implements Action {
  readonly type = LOAD_ACADEMIC_STUDENTS_FAIL;
  constructor(public payload: any) {}
}

export class UpdateAcademicStudentsFail implements Action {
  readonly type = UPDATE_ACADEMIC_STUDENTS_FAIL;
  constructor(public payload: any) {}
}

export class BulkUpdateAcademicStudentsFail implements Action {
  readonly type = BULK_UPDATE_ACADEMIC_STUDENTS_FAIL;
  constructor(public payload: any) {}
}

export class UpdateAcademicStudentsProjectionFail implements Action {
  readonly type = UPDATE_ACADEMIC_STUDENTS_PROJECTION_FAIL;
  constructor(public payload: any) {}
}

// action types
export type StudentAction =
  // ALL STUDENTS
  | BulkUpdateStudents
  | BulkUpdateStudentsSuccess

  // MY_STUDENTS
  | LoadMyStudents
  | UpdateMyStudents
  | BulkUpdateMyStudents
  | LoadMyStudentsSuccess
  | UpdateMyStudentsSuccess
  | BulkUpdateMyStudentsSuccess
  | UpdateMyStudentsProjectionSuccess
  | LoadMyStudentsFail
  | UpdateMyStudentsFail
  | BulkUpdateMyStudentsFail
  | BulkUpdateStudentsFail
  | UpdateMyStudentsProjectionFail
  | UpdateMyStudentsSort
  | UpdateMyStudentsDimensions

  // ATTENDANCE_STUDENTS
  | LoadAttendanceStudents
  | UpdateAttendanceStudents
  | BulkUpdateAttendanceStudents
  | LoadAttendanceStudentsSuccess
  | UpdateAttendanceStudentsSuccess
  | BulkUpdateAttendanceStudentsSuccess
  | UpdateAttendanceStudentsProjectionSuccess
  | LoadAttendanceStudentsFail
  | UpdateAttendanceStudentsFail
  | BulkUpdateAttendanceStudentsFail
  | UpdateAttendanceStudentsProjectionFail
  | UpdateAttendanceStudentsSort
  | UpdateAttendanceStudentsDimensions

  // ACADEMIC STUDENTS
  | LoadAcademicStudents
  | UpdateAcademicStudents
  | BulkUpdateAcademicStudents
  | LoadAcademicStudentsSuccess
  | UpdateAcademicStudentsSuccess
  | BulkUpdateAcademicStudentsSuccess
  | UpdateAcademicStudentsProjectionSuccess
  | LoadAcademicStudentsFail
  | UpdateAcademicStudentsFail
  | BulkUpdateAcademicStudentsFail
  | UpdateAcademicStudentsProjectionFail
  | UpdateAcademicStudentsSort
  | UpdateAcademicStudentsDimensions;
